import { useQuery } from "@tanstack/react-query";
import { tierStyle } from "@/lib/tierStyle";

interface Inviter {
  id: string;
  displayName: string | null;
  firstName: string | null;
  count: number;
  tier: string;
}

export function CommunityChampions() {
  const { data: top = [] } = useQuery<Inviter[]>({
    queryKey: ["/api/leaderboard/top-inviters"],
    queryFn: async () => {
      const res = await fetch("/api/leaderboard/top-inviters", { credentials: "include" });
      if (!res.ok) return [];
      return res.json();
    },
    staleTime: 10 * 60_000,
  });

  if (top.length === 0) return null;

  const podium = top.slice(0, 3);

  return (
    <div className="border-b bg-muted/40">
      <div className="container mx-auto px-4 py-2.5">
        <div className="flex items-center gap-3 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          <span className="shrink-0 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            Thanks to
          </span>
          <div className="flex items-center gap-2">
            {podium.map((inv) => {
              const name = inv.displayName || inv.firstName || "A neighbor";
              const style = tierStyle(inv.tier);
              return (
                <span
                  key={inv.id}
                  className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${style.className}`}
                  title={`${inv.count} neighbors invited · ${inv.tier}`}
                >
                  <span>{style.icon}</span>
                  <span className="max-w-[14ch] truncate">{name}</span>
                  <span className="opacity-70">· {inv.count}</span>
                </span>
              );
            })}
          </div>
          <span className="ml-auto shrink-0 text-[11px] text-muted-foreground">
            for inviting neighbors
          </span>
        </div>
      </div>
    </div>
  );
}
